<template>
  <div class="item">
    <div class="item-name">
      <p>{{ this.itemName }}</p>
    </div>
    <div class="item-value" v-if="itemValue">
      <p>S${{ this.itemValue }}</p>
    </div>
    <div class="item-quantity">
      <p>Qty: {{ this.itemQuantity }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderSummaryItemView",
  props: ["itemName", "itemValue", "itemQuantity"],
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 20px 0;
  border-bottom: #f1f1f1 solid 1.5px;

  p {
    text-align: center;
    color: white;
  }

  .item-name {
    flex-basis: 34%;
  }

  .item-value {
    flex-basis: 33%;
  }

  .item-quantity {
    flex-basis: 33%;
  }
}
</style>
